class LoadingManager {
    private isLoading = false;
    private overlay: HTMLElement | null = null;

    show() {
        if (this.isLoading) return;
        this.isLoading = true;

        this.overlay = document.createElement('div');
        this.overlay.className = 'fixed inset-0 bg-black/20 flex items-center justify-center z-[9999] cursor-wait';
        this.overlay.innerHTML = '<div class="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>';

        document.body.appendChild(this.overlay);
    }

    hide() {
        if (!this.isLoading || !this.overlay) return;
        this.isLoading = false;

        document.body.removeChild(this.overlay);
        this.overlay = null;
    }
}

export const loadingManager = new LoadingManager();